import MoreVertIcon from "@mui/icons-material/MoreVert";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Typography from "components/common/Typography";
import { useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { getUIFormatDate } from "utils/DateHelper";
import DeleteDialog from "./deleteDialog";
import { setShowDeleteDialog } from "./sme.slice";

const MyListItem = (props: any) => {
  const dispatch = useAppDispatch();
  const { data, onSelect, selected } = props;
  const { showDeleteDialog, dialogId } = useAppSelector((state) => state.sme);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const activeStyle =
    selected && selected === data?.id?.toString()
      ? { backgroundColor: tokens.Background.General.Tertiary, borderRadius: "4px" }
      : {};

  const handleOpenListMenu = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleCloseListMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenDeleteDialog = () => {
    dispatch(setShowDeleteDialog({ show: true, dialogId: data?.id }));
    setAnchorEl(null);
  };

  return (
    <>
      <Stack
        direction="row"
        sx={{ padding: "12px 8px", cursor: "pointer", ...activeStyle }}
        onClick={() => onSelect(data)}
      >
        <Box sx={{ width: "88%" }}>
          <Typography
            variant="body1"
            color={tokens.Text.General.PrimaryHeadline}
            sx={{
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              overflow: "hidden"
            }}
          >
            {data.name}
          </Typography>
          <Stack>
            <Typography
              variant="label"
              color={tokens.Text.General.PrimaryBody}
              sx={{
                fontSize: "12px"
              }}
            >
              Inncodes - {data.mappingsCount}
            </Typography>
            <Typography
              variant="label"
              color={tokens.Text.General.PrimaryBody}
              sx={{
                fontSize: "12px"
              }}
            >
              Upload Date - {getUIFormatDate(data.createdDate)}
            </Typography>
          </Stack>
        </Box>
        <IconButton aria-label="list-menu" onClick={handleOpenListMenu}>
          <MoreVertIcon />
        </IconButton>
      </Stack>
      <Menu
        id="list-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseListMenu}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "8px",
            boxShadow: "0px 10px 25px 0px rgba(19, 41, 138, 0.10), 0px 0px 4px 0px rgba(19, 41, 138, 0.10)",
            minWidth: "200px",

            "& li": {
              padding: "8px 16px"
            }
          }
        }}
      >
        {/* <MenuItem onClick={handleCloseListMenu}>Assign Plan</MenuItem> */}
        <MenuItem onClick={handleOpenDeleteDialog} sx={{ color: tokens.Icon.Feeback.Alert }}>
          Delete List
        </MenuItem>
      </Menu>
      {dialogId === data?.id && <DeleteDialog open={showDeleteDialog} data={data} />}
    </>
  );
};

export default MyListItem;
